import { motion } from 'framer-motion';
import {
  Package, Code2, GraduationCap, PlaySquare,
  FlaskConical, Dumbbell, UtensilsCrossed, ShoppingBag
} from 'lucide-react';

const industries = [
  { icon: Package, label: 'Subscription Boxes' },
  { icon: Code2, label: 'SaaS' },
  { icon: GraduationCap, label: 'Online Coaching' },
  { icon: PlaySquare, label: 'Course Platforms' },
  { icon: FlaskConical, label: 'Supplement Brands' },
  { icon: Dumbbell, label: 'Fitness Apps' },
  { icon: UtensilsCrossed, label: 'Meal Kits' },
  { icon: ShoppingBag, label: 'DTC Subscriptions' },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export default function WhoWeServe() {
  return (
    <section data-testid="who-we-serve-section" className="py-28 px-6 lg:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A1628]/40 mb-4">
            Industries
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#0A1628]">
            Built for subscription-first businesses
          </h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-2 sm:grid-cols-4 gap-4"
        >
          {industries.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <motion.div
                key={ind.label}
                variants={itemVariants}
                data-testid={`industry-card-${i}`}
                whileHover={{ y: -4, boxShadow: '0 16px 48px rgba(10,22,40,0.09)' }}
                className="bg-[#FAFAF7] rounded-2xl p-6 flex flex-col items-center gap-4 border border-[#0A1628]/5 cursor-default transition-shadow duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#00D4B8]/10 flex items-center justify-center">
                  <Icon size={24} strokeWidth={1.5} className="text-[#0A1628]" />
                </div>
                <span className="text-sm font-semibold text-[#0A1628] text-center leading-snug">
                  {ind.label}
                </span>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
